import styled from 'styled-components'
import { Borders, Colors } from '../../constants'

export const PageContent = styled.div`
  margin: 30px auto 0 auto;
  position: relative;
  width: 100%;
  max-width: 400px;
  border: 1px solid ${Borders.LightColor};
  border-radius: ${Borders.Radius};
  background-color: ${Colors.White};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
`
